/*
 * • FCSE Travelsearch Sandbox 2013 •
 * 
 * © Copyright 2013, Tom Hülser [freshcells systems engineering GmbH]
 * 
 * 
 */

/**
 * Generic request handler. Handles:
 * 1. Ajax requests
 * 2. Errors
 * 3. Ajax cancelling
 *
 * @author Hermann Bier, bier@freshcells.de
 */

define(
['jQuery', 'log', 'underscore', 'library/fcse-util/url', 'Routing', 'RoutingData', 'underscore'],
function ($, Log, _, Url, Routing, RoutingData, _) {
    /**
     * Request constructor
     */
    var Request = function (config) {
        if ($.isPlainObject(config)) {
            this.setup(config);
        }
        var url = new Url();
        this.locale = url.getLocale();
    };

    Request.prototype = (function () {
        /*
         * Private scope
         */
        var config = {};
        var log = new Log();
        var syncNodeSet = []; // dom nodes to synchronize requests
        var syncRouteSet = {}; // routes to sync requests

        /**
         * Checks whether request properly set up
         */
        function checkConfig(config) {
            // check whether all routes exist
            _.each(_.keys(config), function (route) {
                // Routing.getRoute throws exception if route is not found
                Routing.getRoute(route);
            });
        }


        /**
         * Called on ajax done
         * Note: It is possible to have ajax calls without callback at all.
         */
        function ajaxDone(route, callback, response, status, jqXHR) {
            if (typeof callback != 'function') { // if now callback give move the params
                jqXHR = status;
                status = response;
                response = callback;
            }

            // we can get json or html
            if (_.isObject(response)) {
                if (_.has(response, 'error') && response.error !== false) {
                    log.error('Route: ' + route + ' returned an error', response.error);

                    if (_.has(config[route], 'errorHandler')) {
                        config[route].errorHandler(response.error);
                    }
                }
                else {
                    if (typeof callback == 'function') {
                        callback(response, status, jqXHR);
                    }
                    if (_.has(config[route], 'callback')) {
                        config[route].callback(response, status, jqXHR);
                    }
                }
            } else {
                callback(response);
            }
        }

        /**
         * Creates new route config if not already
         */
        function createRouteConfig(route) {
            if (!_.has(config, route)) {
                config[route] = {};
            }
        }

        /**
         * Handle cancelling. There are two ways of cancelling an ajax request:
         * 1. syncNode: ajax requests are synchronized on a dom element. In the first case syncNode is the same node.
         * Previous call is cancelled if second call comes in with same syncNode. In the second case first syncNode is
         * ancestor of seconds call syncNode, so the call for childSyncNode is cancelled.
         * 2. synchronisation is done on route names. If a call for route say 'booking.check' is there second call for this
         * route will cancel the first one and so on.
         *
         */
        function processCancelling(route, jqXHR, sync, parentCancel) {
            if (typeof sync != 'string') {// sync on nodes
                var syncNode = sync;
                syncNode = $(syncNode);
                // get previous request
                if (!parentCancel && syncNode.data('request') && syncNode.data('request').readyState != 4) {
                    log.debug('Aborting request for syncNode: ', syncNode);
                    syncNode.data('request').abort();
                }

                // look whether there are children syncnodes
                _.each(syncNodeSet, function (node) {
                    node = $(node); // node is not jquery wrapped
                    if (syncNode.has(node).length > 0 && node.data('request').readyState != 4) {
                        log.debug('Aborting child syncNode request for: ', syncNode, node);
                        node.data('request').abort();
                    }
                });

                syncNode.data('request', jqXHR);
                if (_.indexOf(syncNodeSet, syncNode[0]) < 0) {
                    syncNodeSet.push(syncNode[0]);
                }
            }
            else if (sync == 'abort') {// sync on routes
                if (_.has(syncRouteSet, route) && syncRouteSet[route].readyState != 4) {
                    log.debug('Aborting request for route: ' + route);
                    syncRouteSet[route].abort();
                }
                syncRouteSet[route] = jqXHR;
            }
        }


        /*
         * Public scope
         */
        return {
            constructor: Request,
            /**
             * Setup of request
             */
            setup: function (inputConfig) {
                config = inputConfig;
                checkConfig(config);
                _.each(config, function (routeConfig) {
                    // error handlers
                    var errorHandler = routeConfig.errorHandler;
                    if (typeof errorHandler == 'string') {// error handler of other route is given
                        errorHandler = _.getProperty(config, routeConfig.errorHandler).errorHandler;
                    }
                    routeConfig.errorHanlder = errorHandler;

                    // callbacks
                    var callback = routeConfig.callback;
                    if (typeof callback == 'string') {// callback of other route given
                        callback = _.getProperty(config, routeConfig.callback).callback;
                    }
                    if (_.has(routeConfig, 'callback')) {
                        routeConfig.callback = callback;
                    }
                });
            },


            /**
             * Set error handler for route
             */
            setErrorHandler: function (route, handler) {
                createRouteConfig(route);
                config[route].errorHandler = handler;
            },

            /**
             * Set callback for route
             */
            setCallback: function (route, callback) {
                createRouteConfig(route);
                config[route].callback = callback;
            },

            /**
             * Set ajax call params. For ex. type, dataType
             * Function has two modes
             */
            setAjaxParams: function (route, key, value) {
                createRouteConfig(route);
                if (_.isObject(key)) {
                    config[route].ajaxParams = key;
                }
                else {
                    if (!_.has(config[route], 'ajaxParams')) {
                        config[route].ajaxParams = {};
                    }
                    config[route].ajaxParams[key] = value;
                }
            },

            /**
             * Returns boolean whether a request for a route is done or running.
             * @param {string} route Route key to check the status for.
             * @return boolean
             */
            isRunning: function (route) {
                return _.has(syncRouteSet, route) && syncRouteSet[route].readyState != 4;
            },

            /**
             * Makes ajax call.
             * Function call:
             * send(route, [callback], routeParams, queryParams, sync);
             *
             * type of sync is ['prevent', 'abort'] | DomNode
             *
             * callback is optional. If not set as argument, it should be set per setup() or setCallback() before.
             *
             * @param {string} route Route key, for ex. booking.check
             * @param {function} complete Optional callback function, executed on ajax complete
             * @param {object} routeParams Route params. Placeholder in route will be replaced. Set null if nothing to replace
             * @param {object} queryParams Parameters sent to server
             * @param {string} cancel Cancelling method.
             *                  'prevent': no further call made until previous one ends.
             *                  'abort': each previous call is aborted.
             *                  syncNode: synchronisation among dom node.
             * @param {boolean} parentCancel Restrict canceling only by parent syncnode.
             *                  e.g. when you want to allow multiple parallel calls in a nested component
             *                  and at the same time should abort these calls when parent abort and starts new call.
             * @return void
             */
            send: function (route, complete, routeParams, queryParams, cancel, parentCancel) {

                createRouteConfig(route);

                // prevent
                if (cancel == 'prevent' && this.isRunning(route)) {
                    log.debug('Prevent request for route: ' + route);
                    return;
                }

                // care about optional callback argument
                if (typeof complete != 'function') {// without callback
                    cancel = queryParams;
                    queryParams = routeParams;
                    routeParams = complete;
                }
                routeParams = routeParams || {};
                routeParams["_locale"] = this.locale;

                // Generating URL for route.
                // Routing adds unused query parameters to query string, we don't want that, so we remove those
                var url = Routing.generate(route, routeParams).replace(/\?.+/, "");

                // prepare ajax
                var ajaxParams = {
                    url: url,
                    data: queryParams,
                    cache: false
                };

                if (_.has(config[route], 'ajaxParams')) {
                    ajaxParams = $.extend(true, ajaxParams, config[route].ajaxParams);
                }

                var jqXHR = $.ajax(ajaxParams).done(function (response, status, jqXHR) {
                    if (typeof complete != 'function') { // use callback from config
                        ajaxDone(route, response, status, jqXHR);
                    }
                    else { // use given callback
                        ajaxDone(route, complete, response, status, jqXHR);
                    }
                }).fail(function (jqXHR, status, response) {
                        log.error('Route: ' + route + ' HTTP error occurred. Status: ' + jqXHR.status + ' Text: ' + jqXHR.statusText);
                        if (_.has(config[route], 'errorHandler')) {
                            config[route].errorHandler('responseFail', jqXHR, status, response);
                        }
                    });

                // save request
                // in case of 'abort' cancelling there is an own technic
                if (cancel != 'abort') {
                    syncRouteSet[route] = jqXHR;
                }

                // ajax cancelling
                if (cancel || config[route].cancelling) {
                    processCancelling(route, jqXHR, cancel, parentCancel);
                }
            }
        };
    })();

    return Request;
});



//////////////////
// WEBPACK FOOTER
// ./~/fcse-request/request.js
// module id = 233
// module chunks = 7 8 9 10 11 12 13 14